import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";

export function NotificationBell() {
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  function load() {
    api.getNotifications().catch(() => {}).then(data => {
      if (Array.isArray(data)) setNotifications(data);
    });
  }

  useEffect(() => {
    load();
    const interval = setInterval(load, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    function handleClick(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  async function dismiss(id) {
    await api.dismissNotification(id).catch(() => {});
    setNotifications(prev => prev.filter(n => n.id !== id));
  }

  async function dismissAll() {
    await api.dismissAllNotifications().catch(() => {});
    setNotifications([]);
    setOpen(false);
  }

  function handleNotificationClick(n) {
    if (n.invoice_id) {
      navigate(`/invoices/${n.invoice_id}`);
      setOpen(false);
    }
  }

  const unread = notifications.length;

  const iconStyle = (type) => {
    if (type === "dispute_resolved") return { bg: "#D1FAE5", color: "#065F46", icon: "✓" };
    if (type === "tickets_available") return { bg: "#DBEAFE", color: "#1E40AF", icon: "📄" };
    return { bg: "#FEF3C7", color: "#92400E", icon: "ℹ" };
  };

  return (
    <div ref={dropdownRef} style={{ position: "relative" }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          background: "none", border: "none", cursor: "pointer",
          position: "relative", padding: "6px 8px", borderRadius: 8,
          color: "var(--text-muted)", fontSize: "1.2rem", lineHeight: 1,
          transition: "background 0.15s",
        }}
        title="Notifications"
      >
        🔔
        {unread > 0 && (
          <span style={{
            position: "absolute", top: 2, right: 2,
            background: "#dc3545", color: "white",
            borderRadius: "50%", width: 18, height: 18,
            fontSize: "0.65rem", fontWeight: 700,
            display: "flex", alignItems: "center", justifyContent: "center",
            lineHeight: 1,
          }}>
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>

      {open && (
        <div style={{
          position: "absolute", right: 0, top: "calc(100% + 8px)",
          width: 340, background: "#fff", borderRadius: 10,
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)", border: "1px solid var(--border)",
          zIndex: 500, overflow: "hidden",
        }}>
          <div style={{
            display: "flex", justifyContent: "space-between", alignItems: "center",
            padding: "12px 16px", borderBottom: "1px solid var(--border)",
          }}>
            <strong style={{ fontSize: "0.9rem" }}>Notifications</strong>
            {unread > 0 && (
              <button onClick={dismissAll} style={{
                background: "none", border: "none", color: "var(--blue)",
                cursor: "pointer", fontSize: "0.78rem", padding: 0,
              }}>
                Dismiss all
              </button>
            )}
          </div>

          {notifications.length === 0 ? (
            <div style={{ padding: "24px 16px", textAlign: "center", color: "var(--text-muted)", fontSize: "0.875rem" }}>
              No new notifications
            </div>
          ) : (
            <div style={{ maxHeight: 380, overflowY: "auto" }}>
              {notifications.map(n => {
                const style = iconStyle(n.type);
                return (
                  <div key={n.id} style={{
                    display: "flex", gap: 10, padding: "12px 16px",
                    borderBottom: "1px solid var(--border)",
                    cursor: n.invoice_id ? "pointer" : "default",
                    transition: "background 0.1s",
                  }}
                    onClick={() => handleNotificationClick(n)}
                    onMouseEnter={e => e.currentTarget.style.background = "var(--bg)"}
                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                  >
                    <div style={{
                      width: 32, height: 32, borderRadius: "50%",
                      background: style.bg, color: style.color,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: "0.9rem", flexShrink: 0,
                    }}>
                      {style.icon}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: "0.83rem", color: "var(--text)", lineHeight: 1.4 }}>
                        {n.message}
                      </div>
                      <div style={{ fontSize: "0.72rem", color: "var(--text-muted)", marginTop: 3 }}>
                        {new Date(n.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}
                      </div>
                    </div>
                    <button
                      onClick={e => { e.stopPropagation(); dismiss(n.id); }}
                      style={{
                        background: "none", border: "none", color: "var(--text-muted)",
                        cursor: "pointer", fontSize: "1rem", padding: "0 4px",
                        flexShrink: 0, lineHeight: 1,
                      }}
                      title="Dismiss"
                    >
                      ×
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
